export const DASHBOARD_PATH = '/dashboard';
export const SHOPFLOOR_PATH = '/shopfloor';
export const ALERTS_PATH = '/alerting';
export const SETTINGS_PATH = '/settings';

export const SETUP_PATH = '/setup';
export const SETUP_HARDWARE_PATH = '/setup/hardware';
export const SETUP_FLOW_PATH = '/setup/flow';
export const SETUP_DISPLAY_PATH = '/setup/display';
export const SETUP_SIGNALS_PATH = '/setup/signals';
export const SETUP_FILES_PATH = '/setup/files';

export const CONTROLLERS_PATH = '/controllers';
export const CONTROLLERS_USB_PATH = '/controllers/usb';
export const INSTANCES_PATH = '/instances';

export const SETUP_CONTROLLER_KEY = 'vcs-setup-controller';

export type SetupTabId = 'flow' | 'display' | 'signals';

export const SETUP_TABS: { id: SetupTabId; path: string; labelKey: string }[] = [
  { id: 'flow', path: SETUP_FLOW_PATH, labelKey: 'nav.flow' },
  { id: 'display', path: SETUP_DISPLAY_PATH, labelKey: 'nav.layout' },
  { id: 'signals', path: SETUP_SIGNALS_PATH, labelKey: 'nav.signals' },
];

const SETUP_BY_PATH = new Map(SETUP_TABS.map((tab) => [tab.path, tab.id]));

export function setupTabFromPath(pathname: string): SetupTabId {
  return SETUP_BY_PATH.get(pathname) || 'flow';
}

export function readControllerId(params: URLSearchParams): string {
  return params.get('id') || params.get('device') || '';
}

export function writeControllerId(params: URLSearchParams, id: string): URLSearchParams {
  const next = new URLSearchParams(params);
  if (id) {
    next.set('id', id);
  } else {
    next.delete('id');
  }
  next.delete('device');
  return next;
}

export function rememberControllerId(id: string): void {
  try {
    if (id) {
      sessionStorage.setItem(SETUP_CONTROLLER_KEY, id);
    }
  } catch {
    // ignore
  }
}

export function rememberedControllerId(): string {
  try {
    return sessionStorage.getItem(SETUP_CONTROLLER_KEY) || '';
  } catch {
    return '';
  }
}

export function controllerDetailPath(id: string): string {
  return `${CONTROLLERS_PATH}/${encodeURIComponent(id)}`;
}

export function controllerHardwarePath(id: string, instance?: string): string {
  const base = `${CONTROLLERS_PATH}/${encodeURIComponent(id)}/hardware`;
  if (!instance) {
    return base;
  }
  return `${base}?instance=${encodeURIComponent(instance)}`;
}

export function controllerFilesPath(id: string): string {
  return `${CONTROLLERS_PATH}/${encodeURIComponent(id)}/files`;
}

export function setupHardwarePath(id: string, instance?: string): string {
  return controllerHardwarePath(id, instance);
}

export function setupFlowPath(id: string): string {
  return `${SETUP_FLOW_PATH}?id=${encodeURIComponent(id)}`;
}

export function setupSignalsPath(id: string): string {
  return `${SETUP_SIGNALS_PATH}?id=${encodeURIComponent(id)}`;
}

export function setupDisplayPath(id?: string, path?: string): string {
  const params = new URLSearchParams();
  if (id) params.set('id', id);
  if (path) params.set('path', path);
  const query = params.toString();
  return query ? `${SETUP_DISPLAY_PATH}?${query}` : SETUP_DISPLAY_PATH;
}

export function setupFilesPath(id?: string): string {
  if (!id) return CONTROLLERS_PATH;
  return controllerFilesPath(id);
}
